import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { FormattedMessage, injectIntl } from 'react-intl';
// Style
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ReservationContainer.css';

// Graphql
import getAllReservationQuery from './getAllReservationQuery.graphql';

// Component
import SideMenu from '../../components/ManageListing/SideMenu';
import Reservation from '../../components/Reservation';
import NoItem from '../../components/Reservation/NoItem';
import Loader from '../../components/Loader';
import CustomPagination from '../../components/CustomPagination';
import DashboardListings from '../../components_new/dashboard/DashboardListings';

// Locale
import messages from '../../locale/messages';
import { ViewBox } from '../../components_new/common';
import moment from 'moment';

class ReservationContainer extends React.Component {
  static propTypes = {
    formatMessage: PropTypes.func,
    userType: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getAllReservation: PropTypes.shape({
        count: PropTypes.number,
        reservationData: PropTypes.array,
      }),
      refetch: PropTypes.func,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      filters: {},
    };
    this.paginationData = this.paginationData.bind(this);
  }

  paginationData(currentPage) {
    const {
      data: { refetch },
    } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  filtersChanged = filters => {
    const { data } = this.props;
    this.setState({ filters }, () => {
      const newFilters = this.state.filters; //these were merged, we need all of them.
      data.fetchMore({
        variables: newFilters,
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;
          return Object.assign({}, fetchMoreResult);
        },
      });
    });
  };

  render() {
    const {
      data: { loading, getAllReservation },
      userType,
      type,
    } = this.props;
    const { currentPage } = this.state;
    const { formatMessage } = this.props.intl;
    const title =
      type == 'current' ? (
        <FormattedMessage {...messages.upcomingReservations} />
      ) : (
        <FormattedMessage {...messages.previousReservations} />
      );

    return (
      <div className={s.container}>
        <Grid>
          <Row className={s.landingContainer}>
            <SideMenu />
            <ViewBox noPadding>
              <div className="t t-m">
                <div className="bg-coolGrayLightest p-m">Reservations</div>
                {loading && <Loader type={'text'} />}
                {!loading &&
                  getAllReservation !== undefined &&
                  getAllReservation !== null && (
                    <Reservation
                      data={getAllReservation.reservationData}
                      userType={userType}
                    />
                  )}
                {getAllReservation !== undefined &&
                  getAllReservation !== null &&
                  getAllReservation.reservationData.length > 0 && (
                    <CustomPagination
                      total={getAllReservation.count}
                      currentPage={currentPage}
                      defaultCurrent={1}
                      defaultPageSize={10}
                      change={this.paginationData}
                      paginationLabel={formatMessage(messages.panelReservation)}
                    />
                  )}
                {!loading &&
                  getAllReservation !== undefined &&
                  getAllReservation !== null &&
                  getAllReservation.reservationData.length === 0 && (
                    <NoItem userType={userType} type={type} />
                  )}
              </div>
            </ViewBox>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
  graphql(getAllReservationQuery, {
    options: props => ({
      variables: {
        userType: props.userType,
        current: props.type === 'current',
      },
      fetchPolicy: 'network-only',
      ssr: false,
    }),
  }),
  // graphql(getAllReservationQuery, {
  //   options: props => ({
  //     variables: {
  //       userType: props.userType,
  //       year: moment().year(),
  //       month: 0,
  //     },
  //     fetchPolicy: 'network-only',
  //     ssr: false,
  //   }),
  // }),
)(ReservationContainer);



// WEBPACK FOOTER //
// ./src/routes/reservation/ReservationContainer.js